export const dictionary = {
    courseHistory: "개설이력",
    notOffered: "미개설",
    courseCountInfo1: "총 <bold>{{count}}</bold>개 과목<space/>",
    courseCountInfo2: "(<icon/>: 이번 학기 개설)",
    sort: "정렬",
    noResults: "결과 없음",
    sortOptions: {
        code: "과목코드순",
        popularity: "인기순",
        studentCount: "수강자 많은 순",
    },
    review: "과목 후기",
    reviewLanguage: "언어",
    reviewLanguageOptions: {
        all: "전체",
        english: "영어",
    },
}
